import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import CreateTournamentModal from './CreateTournamentModal'
import config from '../config'
import { AuthContext } from '../context/AuthContext'
import '../styles/Tournament.css'
import '../styles/Leaderboard.css'
import { formatCurrency as fc } from '../helper/StylesHelper'
import { LoadingSpinner } from '../helper/StylesHelper'

export default function TournamentModal({
  leaderboardId,
  currentLeader,
  percentageGain,
  onClose,
  leaderboardCreator,
}) {
  const {
    userToken,
    isAuthenticated,
    isAdmin,
    userId,
    username: currentUsername,
  } = useContext(AuthContext)
  const [tournaments, setTournaments] = useState([])
  const [selectedType, setSelectedType] = useState('Active')
  const [showCreatePopup, setShowCreatePopup] = useState(false)
  const [loading, setLoading] = useState(true)
  const [showOlder, setShowOlder] = useState(false)
  const [olderTournamentsExist, setOlderTournamentsExist] = useState(false)

  useEffect(() => {
    fetchTournaments()
  }, [showCreatePopup, showOlder])

  const fetchTournaments = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `${config.backendUrl}/api/tournaments/${leaderboardId}`
      )
      const allTournaments = response.data.tournaments

      const now = new Date()
      const currentMonth = now.getMonth()
      const currentYear = now.getFullYear()

      const futureOrCurrentTournaments = allTournaments.filter((t) => {
        const tournamentDate = new Date(t.startDate)
        return (
          tournamentDate.getFullYear() > currentYear ||
          (tournamentDate.getFullYear() === currentYear &&
            tournamentDate.getMonth() >= currentMonth)
        )
      })

      setOlderTournamentsExist(
        allTournaments.length > futureOrCurrentTournaments.length
      )

      setTournaments(showOlder ? allTournaments : futureOrCurrentTournaments)
    } catch (error) {
      console.error('Error fetching tournaments:', error)
    } finally {
      setLoading(false)
    }
  }

  const updateTournamentStatus = async (id, status) => {
    try {
      await axios.put(
        `${config.backendUrl}/api/tournaments/${id}/status`,
        {
          status,
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      )
      fetchTournaments()
    } catch (error) {
      console.error('Error updating status:', error)
    }
  }

  const deleteTournament = async (id) => {
    if (!window.confirm('Are you sure you want to delete this tournament?'))
      return
    try {
      await axios.delete(`${config.backendUrl}/api/tournaments/${id}`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      })
      fetchTournaments()
    } catch (error) {
      console.error('Error deleting tournament:', error)
    }
  }

  return (
    <div className="popup-container tournament-popup">
      {!showCreatePopup && (
        <>
          <div className="tournament-header-container">
            <h1 className="tournament-header">Tournament Details</h1>
            <button
              className="CreatePostFeedButton tournament-close-button"
              onClick={onClose}
            >
              Close
            </button>
          </div>
          <div className="tournament-row">
            <div className="tournament-col">
              <div className="tournament-category">
                <button
                  className={`CreatePostFeedButton ${
                    selectedType === 'Active' ? 'goldButton' : ''
                  }`}
                  onClick={() => setSelectedType('Active')}
                >
                  Active
                </button>
                <button
                  className={`CreatePostFeedButton ${
                    selectedType === 'Finished' ? 'goldButton' : ''
                  }`}
                  onClick={() => setSelectedType('Finished')}
                >
                  Finished
                </button>
              </div>
            </div>
            {(isAdmin || currentUsername === leaderboardCreator) && (
              <button
                className="CreatePostFeedButton goldButton"
                onClick={() => setShowCreatePopup(true)}
              >
                Create New
              </button>
            )}
          </div>

          {loading ? (
            <LoadingSpinner />
          ) : tournaments.length === 0 ? (
            <p>No tournaments available</p>
          ) : (
            tournaments
              .filter((t) => t.status === selectedType)
              .map((tournament) => (
                <div key={tournament._id} className="tournament-card">
                  <div className="tournament-col">
                    <h4 className="tournament-details-content">
                      {tournament.title}
                    </h4>
                  </div>
                  <div className="tournament-row">
                    <div className="tournament-col">
                      <label className="tournament-label">Category:</label>
                      <h5 className="tournament-category">
                        {tournament.category}
                      </h5>
                    </div>
                    <div className="tournament-col">
                      <label className="tournament-label">Start date:</label>
                      <h5 className="tournament-startDate">
                        {new Date(tournament.startDate).toLocaleDateString(
                          'en-GB'
                        )}
                      </h5>
                    </div>
                    <div className="tournament-col">
                      <label className="tournament-label">End date:</label>
                      <h5 className="tournament-endDate">
                        {new Date(tournament.endDate).toLocaleDateString(
                          'en-GB'
                        )}
                      </h5>
                    </div>
                  </div>
                  <div className="tournament-row">
                    <div className="tournament-col">
                      <label className="tournament-label">Details:</label>
                      <h5 className="tournament-details">
                        {tournament.details}
                      </h5>
                    </div>
                  </div>
                  <div className="tournament-col">
                    <label className="tournament-label">Current Leader</label>
                    <div className="tournament-current-leader">
                      <h5
                        className="leader-input"
                        style={{ width: '90px', color: '#ffbf19' }}
                      >
                        {currentLeader}
                      </h5>
                      <div style={{ color: '#ffbf19' }}>
                        <span className="LeadGainArrow">
                          ({percentageGain >= 0 ? '↑' : '↓'}
                          {fc(percentageGain, 2, true)}%)
                        </span>
                      </div>
                    </div>
                  </div>
                  {isAdmin && (
                    <div className="tournament-footer-row">
                      {selectedType === 'Active' && (
                        <button
                          className="CreatePostFeedButton"
                          onClick={() =>
                            updateTournamentStatus(tournament._id, 'Finished')
                          }
                        >
                          Mark as Finished
                        </button>
                      )}
                      <button
                        className="CreatePostFeedButton"
                        onClick={() => deleteTournament(tournament._id)}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              ))
          )}
          {/* Show "Load Older" button if older tournaments exist */}
          {olderTournamentsExist && !showOlder && (
            <button
              className="CreatePostFeedButton"
              style={{ marginTop: '10px', border: '1px solid #ffbf19' }}
              onClick={() => setShowOlder(true)}
            >
              Load Older
            </button>
          )}
        </>
      )}
      {showCreatePopup && (
        <CreateTournamentModal
          leaderboardId={leaderboardId}
          onClose={() => setShowCreatePopup(false)}
        />
      )}
    </div>
  )
}
